export default __webpack_public_path__ + "static/media/avatar_sutriono.4591c232.jpg";